import { render, staticRenderFns } from "./ReadinessBlockPattern.vue?vue&type=template&id=5e3b999d&scoped=true&"
import script from "./ReadinessBlockPattern.vue?vue&type=script&lang=js&"
export * from "./ReadinessBlockPattern.vue?vue&type=script&lang=js&"
import style0 from "./ReadinessBlockPattern.vue?vue&type=style&index=0&id=5e3b999d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b999d",
  null
  
)

export default component.exports
import {QCard,QCardSection,QList,QItem,QItemSection,QChip,QDialog,QSpace,QBtn,QItemLabel,QSeparator,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QList,QItem,QItemSection,QChip,QDialog,QSpace,QBtn,QItemLabel,QSeparator}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
